import { getModuleTranslator } from '@utils/get-module-translator'
import { generateId } from '@utils/id'
import moduleConfig from '../../config'

const __mtc = getModuleTranslator(moduleConfig.translationKey)

export const hardwareProperyFieldMap = () => ({
  hardware_property_group: {
    title: __mtc('hardware_property_group'),
    fields: [
      {
        key: generateId(),
        paramName: 'serialNumber',
        name: __mtc('serial_number'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'manufacturerId',
        name: __mtc('manufacturer'),
        inputType: 'manufacturer',
      },
      {
        key: generateId(),
        paramName: 'warrantyStartDate',
        name: __mtc('warranty_start_date'),
        inputType: 'date',
      },
      {
        key: generateId(),
        paramName: 'warrentyExpirationDate',
        name: __mtc('warrenty_expriration_date'),
        inputType: 'date',
      },
      {
        key: generateId(),
        paramName: 'warrantySyncLastDate',
        name: __mtc('warranty_sync_last_date'),
        inputType: 'dateTime',
        viewOnly: true,
      },
      {
        key: generateId(),
        paramName: 'auditDate',
        name: __mtc('audit_date'),
        inputType: 'date',
      },
    ],
  },
})
